import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Trash2 } from 'lucide-react';

export const ContactMessagesTab = ({ contactMessages, deleteContactMessage, formatDate }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Contactberichten</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Datum</TableHead>
                <TableHead>Naam</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Bericht</TableHead>
                <TableHead>Acties</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {contactMessages.map((message) => (
                <TableRow key={message.id}>
                  <TableCell>{formatDate(message.created_at)}</TableCell>
                  <TableCell>{message.name}</TableCell>
                  <TableCell>{message.email}</TableCell>
                  <TableCell>
                    <div className="max-w-md truncate" title={message.message}>
                      {message.message}
                    </div>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => deleteContactMessage(message.id)}
                      className="text-red-600 hover:text-red-700 hover:bg-red-50"
                      data-testid={`delete-contact-${message.id}`}
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {contactMessages.length === 0 && (
            <div className="text-center py-8 text-slate-500">
              Nog geen contactberichten ontvangen.
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
